export default __webpack_public_path__ + "static/media/gallery-wip-pommel_08.6ccae0a6.jpg";